import { css } from "@creditas/stylitas"

export const customDisplay = ({ display }) => css`
  display: ${display};
`
